import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { CellRenderer, CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

export interface MaterialActionsCellRendererParams {
  onExport: (material: any) => void;
}

/**
 * Material Actions Cell Renderer
 *
 * Displays an actions menu for a material row with export functionality.
 * Shows a "more_vert" icon button that opens a menu with export option.
 *
 * @example
 * ```typescript
 * {
 *   colId: 'actions',
 *   headerName: '',
 *   cellRenderer: MaterialActionsCellRendererComponent,
 *   cellRendererParams: {
 *     onExport: (material) => this.exportMaterial(material)
 *   } as MaterialActionsCellRendererParams,
 *   sortable: false,
 *   filterable: false,
 *   width: 80
 * }
 * ```
 */
@Component({
  selector: 'app-material-actions-cell-renderer',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatMenuModule, MatButtonModule],
  template: `
    <div class="flex items-center justify-center">
      <button mat-icon-button [matMenuTriggerFor]="actionMenu" (click)="$event.stopPropagation()">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #actionMenu="matMenu">
        <button mat-menu-item (click)="onExport()">
          <mat-icon svgIcon="heroicons_outline:arrow-down-tray"></mat-icon>
          <span>Exportar Material a Excel</span>
        </button>
      </mat-menu>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      width: 100%;
    }
  `]
})
export class MaterialActionsCellRendererComponent implements CellRenderer<any> {
  @Input() params!: CellRendererParams<any>;

  get customParams(): MaterialActionsCellRendererParams | undefined {
    return this.params?.colDef?.cellRendererParams as MaterialActionsCellRendererParams;
  }

  onExport(): void {
    if (this.customParams?.onExport && this.params.data) {
      this.customParams.onExport(this.params.data);
    }
  }
}
